import { observer } from 'mobx-react';

import { useWidgetAdaptiveText } from '../../../hooks';
import { useCountdownTimer } from '../../../hooks/useCountdownTimer';

import styles from './MetagameWidgetTimer.module.scss';

interface MetagameWidgetTimerTimerProps {
  endDate: Date;
  onEnd: () => void;
  extended?: boolean;
}

function MetagameWidgetTimerComponent(props: MetagameWidgetTimerTimerProps) {
  const { extended, endDate, onEnd } = props;
  const { timer } = useCountdownTimer({ onEnd, endDate });

  const { textRef } = useWidgetAdaptiveText({ padding: 4 });

  return (
    <div className={extended ? styles.containerExtended : styles.container}>
      <span ref={textRef} className={extended ? styles.textExtended : styles.text}>
        {timer}
      </span>
    </div>
  );
}

export const MetagameWidgetTimer = observer(MetagameWidgetTimerComponent);
